import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Currency } from 'src/app/shared/models/currency.model';
import { ProviderList } from 'src/app/shared/models/provider.model';
import { ReportsGatewayService } from './reports-gateway.service';
import { CascadeInvoiceItemsReport } from '../models/cascade-invoice-items-report.model';
import { CascadeInvoiceItemsFilters } from '../models/cascade-invoice-items-filters.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ReportsFacadeService {
    baseUrl = environment.baseUrl;

    constructor(private reportsGatewayService: ReportsGatewayService, private http: HttpClient) { }

    getCurrencies(): Observable<Currency[]> {
        return this.reportsGatewayService.getCurrencies();
    }

    getCascadeInvoiceItemsReport(filters: CascadeInvoiceItemsFilters): Observable<CascadeInvoiceItemsReport[]> {
        return this.reportsGatewayService.getCascadeInvoiceItemReport(filters);
    }

    getDigitalOrders(filters): Observable<any> {
        return this.reportsGatewayService.getDigitalOrders(filters);
    }
    
    getDigitalOrdersArchive(filters): Observable<any> {
        return this.reportsGatewayService.getDigitalOrdersArchive(filters);
    }

    getActivityLogs(filters): Observable<any> {
        return this.reportsGatewayService.getActivityLogs(filters);
    }

    getProviders(filters?: any): Observable<ProviderList> {
        return this.reportsGatewayService.getProviders(filters);
    }


    getRetailerProductList(filters): Observable<any> {
        return this.reportsGatewayService.getRetailerProductList(filters);
    }

    exportRetailerProducts(): Observable<any> {
        return this.reportsGatewayService.exportRetailerProducts();
    }

    getDebitCreditNoteList(filters): Observable<any> {
        return this.reportsGatewayService.getDebitCreditNoteList(filters);
    }

    getSalesReportByDate(filters: any): Observable<any> {
        return this.reportsGatewayService.getSalesReportByDate(filters);
    }
}
